import React from 'react'
import { Typography } from '@mui/material'

import { DropdownsForm } from '../../settings/Dropdowns'

const Setup = ({ dropdownSummary, tab, setTab, updateDropdown }) => {
  return (
    <>
      <Typography>
        To save time in the setup process, we've provided you with some dropdown
        fields that most businesses will need. Customize the dropdown options to
        match your business needs. You can put as many answers as you can think
        of now, but don’t worry you can add more later.
      </Typography>
      <DropdownsForm
        dropdownSummary={dropdownSummary}
        tab={tab}
        setTab={setTab}
        updateDropdown={updateDropdown}
      />
    </>
  )
}

export default Setup
